import Head from 'next/head'
import { Breadcrumb } from '@/commons/Breadcrumb'
import { PersonalTrainerHead } from '../../../components/index/service-category/personal-trainer/PersonalTrainerHead'
import { ClientStoryKimberly } from '../../../components/index/service-category/personal-trainer/ClientStoryKimberly'
import { ClientStoryAgatha } from '../../../components/index/service-category/personal-trainer/ClientStoryAgatha'
import { openModal } from 'service/modal-service'
import { RequestProvider } from 'context/RequestContext'
import { PersonalTrainerBooking } from '../../../components/index/service-category/personal-trainer/PersonalTrainerBooking'
import Script from 'next/script'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { contentDate } from '../../../utils/article-date-time'
import { getRequestJSON } from '../../../api/index/location-api'
import { s3Static } from '../../../utils/constants'
import { ClientStoryNisha } from '@/index/service-category/personal-trainer/ClientStoryNisha'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-10-25'

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps() {

    const { modifiedDate, month, year } = contentDate(CONTENT_REVIEWED);

    const countryName = "Singapore"

    const allRequestCategorySettings = await getRequestJSON(countryName)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Fitness Trainer")

  return {
      props: {
        requestCategorySettings,
        countryName,
        modifiedDate,
        month,
        year
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function SuccessStories(props) {
    const requestCategorySettings = props.requestCategorySettings
    const modifiedDate = props.modifiedDate
    const year = props.year

    const router = useRouter()

    const [requestForm, setRequestForm] = useState(true)

    const requestType = "Fitness Trainer"
    const [isQuickBook, setIsQuickBook] = useState(false)
    const [isCustomBook, setIsCustomBook] = useState(false)

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        openModal(setRequestForm)
    }

  return (
    <>
      <Head>
        <title>Client Success Stories - Personal Trainer Transformations in Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description"
            content="Real client success stories from StringsSG personal trainers in Singapore. See amazing transformations, weight loss, muscle gain, and fitness journeys with certified trainers."/>
        <meta name="keywords"
            content="personal trainer success stories singapore, client transformations, weight loss success stories, fitness trainer results, stringsg testimonials"/>
        <meta name="author" content="StringsSG - Personal Training"/>
        <meta name="google-site-verification"
            content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"  content={`https://www.stringssg.com/sg/personal-trainer/success-stories`} />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content="Client Success Stories - Personal Trainer Transformations in Singapore"/>
        <meta property="og:description" content="Real client success stories from StringsSG personal trainers in Singapore. See amazing transformations, weight loss, muscle gain, and fitness journeys with certified trainers."/>
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-06T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/personal-trainer/female-personal-trainer-training-girl-at-gym.jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@stringssg"/>
        <meta name="twitter:url" content={`https://www.stringssg.com/sg/personal-trainer/success-stories`}/>
        <meta name="twitter:title" content="Client Success Stories - Personal Trainer Transformations in Singapore"/>
        <meta name="twitter:description" content="Real client success stories from StringsSG personal trainers in Singapore. See amazing transformations, weight loss, muscle gain, and fitness journeys with certified trainers."/>
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/personal-trainer/female-personal-trainer-training-girl-at-gym.jpeg" />
        <link rel="canonical" href="https://www.stringssg.com/sg/personal-trainer/success-stories" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Service",
              "name": "Client Success Stories - Personal Trainer Transformations in Singapore",
              "description": "Real client success stories from StringsSG personal trainers in Singapore. See amazing transformations, weight loss, muscle gain, and fitness journeys with certified trainers.",
              "provider": {
                "@type": "Organization",
                "name": "StringsSG",
                "url": "https://www.stringssg.com",
                "sameAs": ["https://www.facebook.com/StringsSG/"]
              },
              "areaServed": "Singapore",
              "url": "https://www.stringssg.com/sg/personal-trainer/success-stories"
            })
          }}
        />
      </Head>
        <div className="">
            <RequestProvider>
                <PersonalTrainerHead
                    breadcrumb={<Breadcrumb jsonLd={false} pageTitle="Success Stories" dark />}
                    heroImage={s3Static + "personal-trainer/female-personal-trainer-training-girl-at-gym.jpeg"}
                    title="Personal Training Client Success Stories - StringsSG"
                    heading="Personal Training Client Success Stories - StringsSG"
                    heroCopy="Real transformations from StringsSG clients - with the programmes and timelines behind them."
                    setIsQuickBook={setIsQuickBook}
                    openRequestForm={openRequestForm}
                    requestForm={requestForm}
                    setRequestForm={setRequestForm}
                    isQuickBook={isQuickBook}
                    isCustomBook={isCustomBook}
                    requestType={requestType}
                    requestCategorySettings={requestCategorySettings}
                />
            </RequestProvider>
            <h2 className='text-3xl md:text-5xl text-center pt-10 px-2 font-bold'>
                Personal Training Client Success Stories - StringsSG
            </h2>
            <p className='text-center leading-relaxed pt-2 pb-10 px-2'>
                We have helped several Singaporeans achieve their health and physique transformation through customized personal training. Here are some of the success stories from our customers.
            </p>
            <div id="nisha">
                <ClientStoryNisha />
            </div>

            <div id="kimberly">
                <ClientStoryKimberly />
            </div>

            <div id="agatha">
                <ClientStoryAgatha />
            </div>

            <RequestProvider>
                <PersonalTrainerBooking
                    setIsQuickBook={setIsQuickBook}
                    openRequestForm={openRequestForm}
                    year={year}
                />
            </RequestProvider>
        </div>
        <Script
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'G-QD1HGGHDYJ');
          }}
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '128634041116395');
                fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
